/**
 * product-benefits.js
 * Initialises the continuous-autoplay Swiper for the slider card(s).
 * Swiper is loaded globally via swiper-bundle.min.js (window.Swiper).
 */
// @ts-nocheck

/* global gsap, ScrollTrigger, Swiper */

function initProductBenefit() {
  document.querySelectorAll('[data-pb-swiper]').forEach((el) => {
    // eslint-disable-next-line no-undef
    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      centeredSlides: true,
      breakpoints: {
        990: {
          spaceBetween: 20,
          centeredSlides: false
        }
      },
      loop: true,
      grabCursor: true,
      watchSlidesProgress: true,
    });

    if (typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined') {
      const gsap = window.gsap;
      const section = el.closest('[data-product-benefits]');
      const wrapper = el.querySelector('.swiper-wrapper');

      if (section && wrapper) {
        gsap.to(wrapper, {
          x: () => -(wrapper.scrollWidth - el.offsetWidth) * 0.3, // Sutil parallax horizontal
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.5,
            invalidateOnRefresh: true,
          }
        });
      }
    }
  });

  initCardStacking();
}

function initCardStacking() {
  if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
    setTimeout(initCardStacking, 100);
    return;
  }

  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;
  gsap.registerPlugin(ScrollTrigger);

  window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });

  // Cleanup existing ScrollTriggers in case of Shopify section reload
  ScrollTrigger.getAll().forEach((st) => {
    if (st.trigger && st.trigger.closest && st.trigger.closest('.product-benefits')) {
      st.kill();
    }
  });

  const sections = document.querySelectorAll('[data-product-benefits]');

  sections.forEach((section) => {
    const cards = gsap.utils.toArray(section.querySelectorAll('.product-benefits__card'));
    if (cards.length < 2) return;

    let mm = gsap.matchMedia();

    mm.add({
      isMobile: "(max-width: 989px)",
      isDesktop: "(min-width: 990px) and (max-width: 1919px)",
      isLargeDesktop: "(min-width: 1920px)"
    }, (context) => {
      let { isMobile, isLargeDesktop } = context.conditions;

      const vwCalc = (px) => isLargeDesktop ? (px / 1920) * window.innerWidth : px;

      const paddingTop = isMobile ? 30 : vwCalc(40);
      const offsetTop = isMobile ? 15 : vwCalc(20);

      cards.forEach((card, i) => {
        card.style.top = `${paddingTop + (i * offsetTop)}px`;
      });

      const lastCard = cards[cards.length - 1];
      const lastStickyTop = paddingTop + ((cards.length - 1) * offsetTop);

      cards.forEach((card, index) => {
        const stickyTop = paddingTop + (index * offsetTop);
        const isLastCard = index === cards.length - 1;

        // Sligthly smaller final scale
        const targetScale = 1 - (0.04 * (cards.length - 1 - index));

        let endTrigger = isLastCard ? card : lastCard;
        // For the last card, animate as it leaves the screen.
        // For others, animate until the last card reaches its sticky position.
        let endValue = isLastCard ? 'bottom top' : `top ${lastStickyTop}px`;

        gsap.to(card, {
          scale: targetScale,
          transformOrigin: "top center",
          ease: "none",
          scrollTrigger: {
            trigger: card,
            start: `top ${stickyTop}px`, // Starts when THIS card hits sticky position
            endTrigger: endTrigger,
            end: endValue,
            scrub: 1,
            invalidateOnRefresh: true,
            markers: false
          }
        });
      });

      return () => {
        cards.forEach(card => card.style.top = '');
      };
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductBenefit);
} else {
  initProductBenefit();
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target && e.target.nodeType === 1 && e.target.querySelector('[data-product-benefits]')) {
    initProductBenefit();
  }
});
